import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { UsersAPI } from '@makyoapp/makyo-sdk/api/Users'
import { getDefaultLocale, IANA_TZ_OPTIONS, LANGUAGE_OPTIONS } from '@makyoapp/makyo-common'
import { Label } from '@makyoapp/makyo-ui'

import { lazyModal } from '@/lib/lazy-load'
import { toasted } from '@/lib/toast'
import useAuth from '@/hooks/useAuth'
import { useReqError } from '@/hooks/useReqError'

import Confetti from '@/assets/confetti1.svg'

const BasicInfoEditModal = lazyModal(() => import('./BasicInfoEditModal'))

interface OnBoardingModalProps {
  show: boolean
}

export default function OnBoardingModal({ show }: OnBoardingModalProps) {
  const { t } = useTranslation()
  const printAPIError = useReqError()
  const { userData, updateProfile } = useAuth()
  const [isLoading, setIsLoading] = useState(false)

  return (
    <BasicInfoEditModal
      isVertical={true}
      show={show}
      header={
        <div className='flex-c pt-2 text-light font-bold text-xl'>
          {t('Welcome to Makyo!')}
          <img src={Confetti} className='size-12' />
        </div>
      }
      modalProps={{
        innerClassName: 'rounded-sm',
      }}
      onHide={undefined}
      name={''}
      bodyClassName={'modal-sm'}
      nameLabel={
        <Label defaultSize={false} className='font-bold text-m-l w-full'>
          {t("What's your name?")}
        </Label>
      }
      title={t('Welcome to Makyo!')}
      withAvatar={false}
      isLoading={isLoading}
      submitLabel={t('Continue')}
      onSubmit={(nextName, _, done) => {
        setIsLoading(true)
        UsersAPI.ReqUpdateProfile({
          _Name: nextName,
          _Language: userData?.lang || LANGUAGE_OPTIONS[0].value,
          _DarkTheme: userData?.theme === 'dark',
          _TimeZone: userData?.timezone || IANA_TZ_OPTIONS[0],
          _Locale: userData?.locale || getDefaultLocale(),
        })
          .then(() => {
            updateProfile({
              name: nextName,
            })
            toasted(t('Profile updated!'))
            return UsersAPI.ReqUpdateOnboarding({
              _Onboarding: false,
            })
          })
          .catch(printAPIError)
          .finally(() => {
            done?.()
            setIsLoading(false)
          })
      }}
    />
  )
}
